import apiClient from "../../../utils/interceptor";
import {
  ApiResponse,
  LocationData,
  CreateLocationParams,
  UpdateLocationParams,
  CreateLocationResponse,
} from "./interface";
import { API_URLS } from "../../../constants";

// Helper to get auth token
const getAuthToken = (): string | null => {
  return localStorage.getItem("auth_token");
};

// Get all locations for a specific company
export const getLocationsByCompanyId = async (
  companyId: string
): Promise<ApiResponse<LocationData[]>> => {
  const token = getAuthToken();

  try {
    const response = await apiClient.get<ApiResponse<LocationData[]>>(
      `${API_URLS.LOCATION.GET_LOCATIONS}/${companyId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching locations:", error);
    throw error;
  }
};

// Create a new location
export const createLocation = async (
  params: CreateLocationParams
): Promise<ApiResponse<CreateLocationResponse>> => {
  const token = getAuthToken();

  try {
    const response = await apiClient.post<ApiResponse<CreateLocationResponse>>(
      API_URLS.LOCATION.CREATE_LOCATION,
      params,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating location:", error);
    throw error;
  }
};

// Update a location
export const updateLocation = async (
  params: UpdateLocationParams
): Promise<ApiResponse<null>> => {
  const token = getAuthToken();

  try {
    const response = await apiClient.patch<ApiResponse<null>>(
      API_URLS.LOCATION.UPDATE_LOCATION,
      params,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating location:", error);
    throw error;
  }
};

// Delete (disable) a location
export const deleteLocation = async (
  locationId: string
): Promise<ApiResponse<null>> => {
  const token = getAuthToken();

  try {
    const response = await apiClient.delete<ApiResponse<null>>(
      API_URLS.LOCATION.DELETE_LOCATION,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: { location_id: locationId },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting location:", error);
    throw error;
  }
};
